import React from 'react';
import App   from 'shared/src/App';


const AppWeb = () => {
  return <App />;
};

export default AppWeb;